import { css } from "styled-components";
import { FlexMixin } from "../../../../../../../../../styles/common/mixins/helpers.styled.js";
const veciHeaderBadgesStyles = {
    TagBadge: ()=>css`
		background-color: ${({ theme  })=>theme.colors.green?.dark};
		clip-path: polygon(0 100%, 100% 50%, 0 0);
		font-size: 0.875rem;
		font-weight: 500;
		height: 64px;
		line-height: 1;
		max-width: 170px;
		padding: 4px 8px;
		text-transform: capitalize;
		top: 10px;
		width: 110px;
		word-spacing: 111px;
		left: 2px;
		border-radius: 0;
		${FlexMixin({
            align: 'center'
        })}
	`
};
export default veciHeaderBadgesStyles;

//# sourceMappingURL=veci.js.map